import React from 'react';
import btu_logo from '@/assets/images/logo.svg';
const Page500 = () => {
	return (
		<main className={ `error__main` }>
			<div className={ `error__container` }>
				<img
					src={ btu_logo }
					alt={ 'logo btu' }
					className={ `error__logo` }
				/>
				<p><strong>500.</strong> Error.</p>
				<p><strong>Niestety wystąpił problem. Prosimy spróbować później.</strong> 
					<br />Nie znamy dokładnej przyczyny problemu.</p>
			</div>
		</main>
	);
};
export default Page500;